module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_works_everywhere.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_works_everywhere.png
// module id = UQlh
// module chunks = 0